'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _aphrodite = require('aphrodite');

var _localizer = require('../util/localizer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NationalId component used to get the user's national ID type and value
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - used with account creation and can be a hidden input
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var STYLES = _aphrodite.StyleSheet.create({
	typeWrapper: {
		margin: '10px 0 0',
		position: 'relative'
	},
	errorMessage: {
		transition: 'all 0.25s ease-in-out'
	},
	dropdown: {
		padding: 0,
		textIndent: 12,
		boxSizing: 'content-box',
		appearance: 'none'
	},
	arrow: {
		position: 'absolute',
		right: 10,
		top: '50%',
		cursor: 'default',
		pointerEvents: 'none'
	},
	arrowError: {
		marginTop: -17
	},
	errorStyles: {
		height: '100%'
	}
});

var NationalId = function (_React$Component) {
	_inherits(NationalId, _React$Component);

	function NationalId() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, NationalId);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NationalId.__proto__ || Object.getPrototypeOf(NationalId)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			idType: _this.props.defaultIdType
		}, _this.handleFocus = function (nationalIdNumber) {
			_this.props.handleFocus(nationalIdNumber);
		}, _this.handleBlur = function (nationalIdNumber) {
			_this.props.handleBlur(nationalIdNumber);
		}, _this.handleChangeNationalIdType = function (event) {
			var nationalIdType = event.target.value;
			_this.setState({ nationalIdType: nationalIdType });
			if (nationalIdType) {
				_this.props.validNationalIdType(nationalIdType);
			} else {
				_this.props.resetNationalId();
			}
			return nationalIdType;
		}, _this.handleChangeNationalNumber = function (nationalIdNumber) {
			_this.setState({ nationalIdNumber: nationalIdNumber });
			if (nationalIdNumber) {
				_this.props.validNationalIdNumber(nationalIdNumber);
			} else {
				_this.props.resetNationalId();
			}
			return nationalIdNumber;
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	/**
 * Call parent's handleFocus
 * @param {String} nationalIdNumber - national ID number
 */


	/**
 * Call parent's handleBlur
 * @param {String} nationalIdNumber - national ID number
 */


	/**
 * handleChangeNationalIdType
 * @param {String} nationalIdType - national ID type
 */


	/**
 * Call parent's handleFocus
 * @param {String} nationalIdNumber - national ID number
 */


	_createClass(NationalId, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var countryInfo = (0, _localizer.getCountryInfo)(this.props.country);
			var _props = this.props,
			    initialValue = _props.value,
			    errorMessageType = _props.errorMessageType,
			    errorMessageNumber = _props.errorMessageNumber,
			    showErrorMessages = _props.showErrorMessages;


			var arrowClassNames = (0, _classnames2.default)((0, _aphrodite.css)(STYLES.arrow), showErrorMessages && errorMessageType && (0, _aphrodite.css)(STYLES.arrowError), {
				'icon icon-arrow-down-small': true
			});

			var typeWrapperClassNames = (0, _classnames2.default)((0, _aphrodite.css)(STYLES.typeWrapper), {
				'vx_has-error-with-message vx_has-error': errorMessageType
			});

			// define the wrapper classNames, which handle showing error messages
			var numberWrapperClassNames = (0, _classnames2.default)((0, _aphrodite.css)(STYLES.typeWrapper), {
				'vx_has-error-with-message vx_has-error': errorMessageNumber
			});

			// define the wrapper classNames, which handle showing error messages
			var errorMessageClassNames = (0, _classnames2.default)((0, _aphrodite.css)(STYLES.errorStyles), {
				'vx_form-control-message': true
			});

			// Getting natiponal id's from props or from localizer
			var nationalIds = this.props.nationalIds || countryInfo.nationalIds;

			return _react2.default.createElement(
				'div',
				null,
				countryInfo.showNationalId && _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: typeWrapperClassNames },
						_react2.default.createElement(
							'select',
							{
								name: 'nationalIdType',
								id: 'nationalIdType',
								className: 'vx_form-control ' + (0, _aphrodite.css)(STYLES.dropdown),
								defaultValue: this.state.idType,
								onChange: function onChange(value) {
									return _this2.handleChangeNationalIdType(value);
								},
								style: STYLES.dropdown },
							_react2.default.createElement(
								'option',
								{ value: '', disabled: true },
								this.props.labelNationalIdType
							),
							nationalIds.map(function (item) {
								return _react2.default.createElement(
									'option',
									{ key: item.label, value: item.value },
									item.label
								);
							})
						),
						_react2.default.createElement('label', { htmlFor: 'nationalIdType', className: arrowClassNames }),
						errorMessageType && showErrorMessages && _react2.default.createElement(
							'div',
							{ className: errorMessageClassNames },
							errorMessageType
						)
					),
					_react2.default.createElement(
						'div',
						{ className: numberWrapperClassNames, style: { margin: '10px 0 0', position: 'relative' } },
						_react2.default.createElement(_reactTextInput2.default, {
							type: 'text',
							name: 'nationalIdNumber',
							id: 'nationalIdNumber',
							className: 'vx_form-control vx_form-control_complex',
							label: this.props.labelNationalIdNumber,
							helpText: this.props.labelNationalIdNumber,
							required: true,
							value: initialValue,
							errorMessage: this.props.errorMessageNumber,
							handleChange: this.handleChangeNationalNumber,
							handleFocus: this.handleFocus,
							handleBlur: this.handleBlur
						}),
						errorMessageNumber && showErrorMessages && _react2.default.createElement(
							'div',
							{ className: errorMessageClassNames },
							errorMessageNumber
						)
					)
				)
			);
		}
	}]);

	return NationalId;
}(_react2.default.Component);

NationalId.propTypes = {
	country: _propTypes2.default.string,
	labelNationalIdType: _propTypes2.default.string,
	labelNationalIdNumber: _propTypes2.default.string,
	helpText: _propTypes2.default.string,
	showErrorMessages: _propTypes2.default.bool,
	value: _propTypes2.default.string,
	errorMessageType: _propTypes2.default.string,
	errorMessageNumber: _propTypes2.default.string,
	defaultIdType: _propTypes2.default.string,
	nationalIds: _propTypes2.default.array,
	changeEmail: _propTypes2.default.func,
	handleFocus: _propTypes2.default.func,
	handleBlur: _propTypes2.default.func,
	resetNationalId: _propTypes2.default.func,
	validNationalIdType: _propTypes2.default.func,
	validNationalIdNumber: _propTypes2.default.func
};
NationalId.defaultProps = {
	showErrorMessages: true,
	handleFocus: function handleFocus() {},
	handleBlur: function handleBlur() {},
	resetNationalId: function resetNationalId() {},
	validNationalIdType: function validNationalIdType() {},
	validNationalIdNumber: function validNationalIdNumber() {}
};
exports.default = NationalId;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/NationalId.js
// module id = 445
// module chunks = 5